// Compatibility name for existing consumers. All Self-Help now reads the same profile setting.
import { useSelfHelpPreference, normalizeSelfHelp } from '../lib/selfHelpPreference';
export const DEFAULT_TOOLTIPS_ENABLED = true;
export const normalizeTooltipsEnabled = normalizeSelfHelp;
export default function useTooltipsEnabled(userId) {
    const { enabled, loaded, setEnabled } = useSelfHelpPreference(userId);
    return { tooltipsEnabled: enabled, loading: !loaded, setTooltipsEnabled: setEnabled };
}
